import type { AppSettings } from '@/storage/types';

/** Applies the theme to <html> (F10.2). "system" follows the OS via the CSS media query. */
export function applyTheme(theme: AppSettings['theme']): void {
  const root = document.documentElement;
  if (theme === 'system') delete root.dataset.theme;
  else root.dataset.theme = theme;
}

/** The theme actually showing, resolving "system" with the OS preference. */
export function resolvedTheme(theme: AppSettings['theme']): 'light' | 'dark' {
  if (theme !== 'system') return theme;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
